import { types as t } from 'mobx-state-tree';
import { KeyValueModel } from '../../key-value.store';
import { BlankUserAnswer } from '../Blank/blank-user-answer.store';
import { BlankCorrectAnswer } from '../CorrectOption/_extends/blank-correct-answer.store';
import { AbstractQuestion } from '../abstract-question.store';
import { AbstractQuestionWithBlanks } from '../abstract-question-with-blanks.store';

const Sentence = AbstractQuestionWithBlanks.named('Sentence');

export const FlowchartDragDropBlankUserAnswer = t.compose(
  t.model({
    userAnswerKey: t.maybeNull(t.number),
  }),
  BlankUserAnswer
);

export const FlowChartDragDropAnswerQuestion = AbstractQuestion.named(
  'FlowChartDragDropAnswerQuestion'
).props({
  heading: t.maybeNull<any>(t.string),
  options: t.array(KeyValueModel),
  userAnswers: t.optional(t.array(FlowchartDragDropBlankUserAnswer), []),
  correctAnswers: t.array(BlankCorrectAnswer),
  sentences: t.array(Sentence),
});
